import styled from 'styled-components';

export const Container = styled.section`
  position: relative;
`;

export const MapContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

export const Lens = styled.div`
  position: absolute;
  width: 200px;
  height: 200px;
  border: 2px solid #000;
  border-radius: 50%;
  pointer-events: none;
  z-index: 10;
  background-repeat: no-repeat;
  background-color: rgba(255, 255, 255, 0.4);
`;

export const FullscreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  touch-action: pan-x pan-y;

  img {
    width: auto;
    height: auto;
    max-width: unset;
    max-height: unset;
    object-fit: contain;
    cursor: grab;
  }
`;
